import axios from '@/plugins/axios'
import { MessageBox, Message } from 'element-ui'

export default {
  namespaced: true,

  state: {
    loading: false,
    regular: [],
    page: 1,
    page_size: 10,
    order_column: 'created_at',
    order_type: 'desc',
    wheres: [
      'Beginning',
      'First Half',
      'Middle',
      'End',
      'Whole video',
      'Nothing'
    ],
    trackDuration: [],
    trackDurationLoader: false,
    credits: ['Shout-Out', 'Video Overlay', 'Nothing']
  },

  mutations: {
    setRegular(state, payload) {
      state.regular = payload
    },
    setPageRegular(state, payload) {
      state.page = payload
    },
    setPageSize(state, payload) {
      state.page_size = payload
    },
    setLoading(state, payload) {
      state.loading = payload
    },
    setTrackDuration(state, data) {
      state.trackDuration = data
    },
    setTrackDurationLoader(state, bool) {
      state.trackDurationLoader = bool
    }
  },

  actions: {
    readRegular({ commit, state }, filters = null) {
      commit('setLoading', true)

      let ls = localStorage.getItem('video_track_scan_filter')
      filters = JSON.parse(ls)

      axios.admin
        .get('vc/video-tracks-scan', {
          params: {
            page: state.page,
            page_size: state.page_size,
            order_column: state.order_column,
            order_type: state.order_type,
            video_type: 1,
            ...filters
          }
        })
        .then(r => {
          commit('setRegular', r.data.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },
    update({ dispatch }, payload) {
      axios.admin
        .post(`vc/video-tracks-scan`, {
          ...payload
        })
        .then(() => {
          dispatch('readRegular')
          Message({
            type: 'success',
            message: 'You have successfully updated record'
          })
        })
    },
    approve({ dispatch }, payload) {
      Object.assign(payload, {
        video_approved: 1
      })
      axios.admin
        .post(`vc/video-tracks-scan`, {
          ...payload
        })
        .then(() => {
          Object.assign(payload, {
            video_approved: 1
          })
          dispatch('readRegular')
        })
    },
    reject({ dispatch }, payload) {
      MessageBox.confirm(`You will return VidCents. Continue?`, 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        Object.assign(payload, {
          video_approved: 0
        })
        axios.admin
          .post(`vc/video-tracks-scan`, {
            ...payload
          })
          .then(() => {
            Message({
              type: 'success',
              message: 'VidCents returned'
            })
            dispatch('readRegular')
          })
          .catch(() => {
            Message({
              type: 'info',
              message: 'VidCents return cancelled'
            })
          })
      })
    },
    async getTrackDuration({ commit }, params) {
      try {
        commit('setTrackDurationLoader', true)
        const trackDuration = await axios.admin.get(
          `acr/track/duration/${params.videoId}/${params.trackId}`
        )
        if (trackDuration.data.success) {
          commit('setTrackDuration', trackDuration.data.trackDuration)
          commit('setTrackDurationLoader', false)
        }
      } catch (e) {
        commit('setTrackDurationLoader', false)
      }
    },
    generateReport() {
      axios.admin
        .get(`vc/video-tracks-scan/report`, {
          responseType: 'blob'
        })
        .then(r => {
          let currentYear = new Date().getFullYear()
          const url = window.URL.createObjectURL(new Blob([r.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'report_videoTracksScan.csv')
          document.body.appendChild(link)
          link.click()
        })
        .catch(e => {
          console.log(e)
        })
    }
  },
}
